import React from "react";
import "./App.css";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./services/store";
import { ApproverPage } from "./pages/ApproverPage";
import { AddEntry } from "./components/add-entry/AddEntry"; // Using the unified AddEntry component
import LoginPage from "./pages/login/LoginCard";
// Import your page components
import VendorDashboard from "./pages/VendorDashboard";
import EmployeeDashboard from "./pages/employee-dashboard/EmployeeDashboard";
import EmployeeBills from "./pages/EmployeeBills";
import { AddEntryEmployee } from "./components/add-entry/AddEntryEmployee";
import ResponsiveAppBar from "./components/Common/ResponsiveAppBar";
import CwcLogoBanner from "./components/Common/CwcLogoBanner";
import DashboardTable from "./pages/DashboardTable";
import ForgotPasswordPage from "./pages/forgot-password";
import RegisterPage from "./pages/register";
import VerifyMobile from "./pages/register/VerifyMobile";
import UserMaintenance from "./components/Employee/ApproverPage/UserMaintenance";
import TdsFileUpload from "./components/Employee/ApproverPage/TdsFileUpload";
import TdsFileDownload from "./components/Vendor/TdsFileDownload";
import SSOPage from "./pages/SSOPage";
import Reports from "./pages/reports";
import GEMInvoices from "./pages/GEMInvoices";
import RejectInvoieOverView from "./components/Reports/RejectInvoieOverView";
import BtsReports from "./pages/BtsReports";
import TdsFileDownloadEmployee from "./components/Vendor/TdsFileDownloadEmployee";
import UserActionLog from "./pages/Activity/UserActionLog";
import TdsFilesUpload from "./components/Employee/ApproverPage/TdsFilesUpload";
import LoginCheck from "./components/login/LoginCheck";
import useAuthSync from "./pages/login/useAuthSync";
// --- The PrivateRoute Component ---
// This should ideally be in its own file (e.g., src/components/PrivateRoute.tsx)
// but placing it here for clarity. It protects routes that require a login.
const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  // This is a simple example. A real app might check a Redux state.
  const isAuthenticated = !!localStorage.getItem("authToken");

  if (!isAuthenticated) {
    // If the user is not authenticated, redirect them to the login page.
    return <Navigate to="/login" replace />;
  }

  // If they are authenticated, render the child component.
  return <>{children}</>;
};

function App() {
  const location = useLocation();
  const pathname = location?.pathname;

  useAuthSync();

  return (
    <Provider store={store}>
      {/* <CssVarsProvider>
      <CssBaseline /> */}
      {/* <ResponsiveAppBar /> */}
      {pathname !== "/login" && <CwcLogoBanner />}
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        {/* --- Public Route --- */}
        {/* Anyone can access the login page. */}
        <Route path="/login" element={<LoginCheck><LoginPage /></LoginCheck>} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-mobile" element={<VerifyMobile />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/user-mentenance" element={<UserMaintenance />} />

        <Route path="/tds-file-upload" element={<TdsFilesUpload />} />
        <Route path="/tds-file-download" element={<TdsFileDownload />} />
        <Route path="/tds-file-download-e" element={<TdsFileDownloadEmployee />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/reject-invoice" element={<RejectInvoieOverView />} />
        <Route path="/gem-invoices" element={<GEMInvoices />} />
        <Route path="/action-logs" element={<UserActionLog />} />

        {/* --- Protected Vendor Routes --- */}
        <Route path="/bills" element={<DashboardTable />} />
        <Route path="/add-new-entry" element={<AddEntry employee={false} />} />
        <Route path="/edit-entry/:id" element={<AddEntry employee={false} />} />
        <Route
          path="/view-invoice-entry/:id" // Added :id for specific invoice viewing
          element={<AddEntry employee={false} />}
        />
        <Route path="/landing_page" element={<VendorDashboard />} />
        <Route path="/btsreports" element={<BtsReports />} />

        {/* --- Protected Employee Routes --- */}
        <Route path="/pending-bills" element={<EmployeeBills isPendingPage />} />

        <Route path="/employee-bills" element={<EmployeeBills />} />
        <Route path="/employee/add-new-entry" element={<AddEntryEmployee employee={true} />} />
        <Route
          path="/employee/view-invoice-entry/:id" // Using a consistent :id parameter
          element={<AddEntryEmployee employee={true} />}
        />
        <Route path="/employee_landing_page" element={<EmployeeDashboard />} />

        {/* --- Protected Approver Route --- */}
        <Route path="/approver-page/:id" element={<ApproverPage />} />
        <Route path="/sso" element={<LoginCheck><SSOPage /></LoginCheck>} />

        {/* --- Fallback / Default Route --- */}
        {/* This will redirect any unknown URL to the login page. */}
        {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
      </Routes>
      {/* </CssVarsProvider> */}
    </Provider>
  );
}

export default App;

